export const createTypingEffect = (
    fullText: string,
    onUpdate: (text: string) => void,
    delay = 5,
): (() => void) => {
    let index = 0;

    const interval = setInterval(() => {
        if (index > fullText.length) {
            clearInterval(interval);
            return;
        }

        onUpdate(fullText.slice(0, index));
        index++;
    }, delay);

    return () => clearInterval(interval);
};
